import { LoadableAfterPaint } from '@confluence/loadable';

import { EditorPageCoverPicturePlaceholder } from './EditorCoverPicture/EditorPageCoverPicturePlaceholder.tsx';
import type { EditorPageCoverPictureComponentProps } from './pageCoverPictureTypes.ts';

export const LazyEditorPageCoverPicture = LoadableAfterPaint<EditorPageCoverPictureComponentProps>({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-EditorCoverPictureEditorPageCoverPicture" */ './EditorCoverPicture/EditorPageCoverPicture.tsx'
			)
		).EditorPageCoverPicture;
	},
	loading: EditorPageCoverPicturePlaceholder,
});
